<template>
  <div>
    <Pane :title="pageTitle"/>
    <a-card class="container">
      <a-form-model layout="inline" :colon="false" :model="form" @keyup.enter.native="query">
        <a-row>
          <a-col :span="18">
            <a-form-model-item>
              <a-input placeholder="设计编号" v-model="form.designCode" style="width: 150px"></a-input>
            </a-form-model-item>

            <a-form-model-item>
              <a-input placeholder="项目名称" v-model="form.projectName" style="width: 150px"></a-input>
            </a-form-model-item>

            <a-form-model-item>
              <a-input placeholder="客户名称" v-model="form.ownerName" style="width: 150px"></a-input>
            </a-form-model-item>

            <a-form-model-item>
              <a-select
                placeholder="责任部门"
                show-search
                :filter-option="$selectFilterOption"
                v-model="form.productionUnit"
                style="width: 150px"
                allow-clear
              >
                <a-select-option v-for="item in productionDepartmentList" :key="item.id" :value="item.id">
                  {{ item.uniqueName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item>
              <a-select placeholder="合同机构" v-model="form.contractOrgType" style="width: 150px" allow-clear>
                <a-select-option value="head">总院</a-select-option>
                <a-select-option value="branch">分院</a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item>
              <a-select placeholder="合同类型" v-model="form.contractType" style="width: 150px" allow-clear>
                <a-select-option v-for="item in contractTypeList" :key="item.value" :value="item.value">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item>
              <a-space>
                <a-button @click="query" type="primary">查看</a-button>
                <a-button @click="reset">重置</a-button>
                <a-button v-if="status === 'PENDING'" type="primary" @click="confirm">确认</a-button>
              </a-space>
            </a-form-model-item>
          </a-col>

          <a-col :span="6">
            <div class="right" style="margin-top: 4px">
              <a-button @click="download" type="primary">导出文件</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form-model>

      <Padding />

      <a-table bordered :data-source="list" :loading="loading" :pagination="false" :scroll="{ x: 1500 }">
        <a-table-column title="设计编号" data-index="designCode" align="center" width="120px" fixed="left">
        </a-table-column>

        <a-table-column title="项目名称" align="center" width="200px">
          <template slot-scope="text">
            <a style="color: #1890ff" @click="goToProgress(text)">{{ text.projectName }}</a>
          </template>
        </a-table-column>

        <a-table-column title="责任部门" data-index="productionUnit" align="center" width="120px">
        </a-table-column>

        <a-table-column title="项目类型" align="center" width="100px">
          <template slot-scope="text">
            <DataDictFinder dictType="projectType" :dictValue="text.projectType" />
          </template>
        </a-table-column>

        <a-table-column title="合同类型" align="center" width="100px">
          <template slot-scope="text">
            <DataDictFinder dictType="contractType" :dictValue="text.contractType" />
          </template>
        </a-table-column>

        <a-table-column title="分院成本系数" align="center" width="100px">
          <template slot-scope="text">
            <span style="color: #1890ff">{{ text.branchCostRatio }}</span>
          </template>
        </a-table-column>

        <a-table-column title="业主" data-index="ownerName" align="center" width="120px">
        </a-table-column>

        <a-table-column title="收入合同额(元)" width="130px" align="right">
          <template slot-scope="text">
            <span style="color: #1890ff">{{ moneyFilter(text.contractAmount) }}</span>
          </template>
        </a-table-column>

        <a-table-column title="分包合同额(元)" width="130px" align="right">
          <template slot-scope="text">
            <span style="color: #1890ff">{{ moneyFilter(text.subcontractAmount) }}</span>
          </template>
        </a-table-column>

        <a-table-column title="必要分包合同额(元)" width="150px" align="right">
          <template slot-scope="text">
            <span style="color: #1890ff">{{ moneyFilter(text.necessarySubcontractAmount) }}</span>
          </template>
        </a-table-column>

        <a-table-column title="本月累计进度(%)" width="120px" align="center">
          <template slot-scope="text">
            <span style="color: #1890ff">{{ progressFilter(text.cumulativeProgress) }}</span>
          </template>
        </a-table-column>

        <a-table-column title="上月累计进度(%)" width="120px" align="center">
          <template slot-scope="text">
            <span style="color: #1890ff">{{ progressFilter(text.lastCumulativeProgress) }}</span>
          </template>
        </a-table-column>

        <a-table-column title="当月进度(%)" width="110px" align="center">
          <template slot-scope="text">
            <span style="color: #1890ff">{{ progressFilter(text.currentMonthProgress) }}</span>
          </template>
        </a-table-column>

        <a-table-column title="当月产值(元)" width="120px" align="right">
          <template slot-scope="text">
            <span style="color: #1890ff">{{ moneyFilter(text.currentMonthOutputValue) }}</span>
          </template>
        </a-table-column>

        <a-table-column title="当月分包成本(元)" width="130px" align="right">
          <template slot-scope="text">
            <span style="color: #1890ff">{{ moneyFilter(text.currentMonthSubcontractCost) }}</span>
          </template>
        </a-table-column>

        <a-table-column title="当月净产值(元)" width="130px" align="right" fixed="right">
          <template slot-scope="text">
            <span style="color: #1890ff">{{ moneyFilter(text.currentMonthNetOutputValue) }}</span>
          </template>
        </a-table-column>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import screen from "@/mixins/screen";
import watermark from "@/mixins/watermark";
import organization from "@/mixins/organization";
import { mapGetters } from "vuex";
import { fetchProgressReportDetail, confirmProgressReport } from "@/api/finance/progress-report";
import { downloadByHtml } from "@/utils/xlsx";

export default {
  name: "progress-report-detail",
  mixins: [screen, watermark, organization],

  data() {
    return {
      reportId: null,
      reportPeriod: "",
      status: null,
      form: {},
      loading: false,
      list: [],
    };
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    contractTypeList() {
      return this.findDataDict("contractType");
    },
    pageTitle() {
      return `${this.reportPeriod || ""}生产进度月报`;
    },
  },

  mounted() {
    const { query } = this.$route;
    this.reportId = (query || {}).reportId || (query || {}).id || null;
    this.reportPeriod = (query || {}).reportPeriod || "";
    this.getList();
  },

  methods: {
    getList() {
      if (!this.reportId) {
        return;
      }
      this.loading = true;
      fetchProgressReportDetail({
        reportId: this.reportId,
        designCode: this.form.designCode,
        projectName: this.form.projectName,
        ownerName: this.form.ownerName,
        productionUnit: this.form.productionUnit,
        contractType: this.form.contractType,
        contractOrgType: this.form.contractOrgType,
      })
        .then((res) => {
          if (res) {
            this.status = res.status;
            this.reportPeriod = res.reportPeriod || this.reportPeriod;
            this.list = Array.isArray(res.detailList) ? res.detailList : [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    query() {
      this.getList();
    },

    reset() {
      this.form = {};
      this.getList();
    },

    confirm() {
      const that = this;
      this.$confirm({
        title: "确认月报",
        content: `确认月报「${this.reportPeriod}」？确认后经管对接人与确认时间将被记录`,
        onOk() {
          return confirmProgressReport({ reportId: that.reportId }).then(() => {
            that.$message.success("确认成功");
            that.getList();
          });
        },
      });
    },

    goToProgress(record) {
      const path = `/produce/progress?code=${encodeURIComponent(record.designCode || "")}`;
      this.$router.push(path).catch(() => {});
    },

    download() {
      downloadByHtml(document.getElementsByTagName("table")[0], "产值进度月报明细");
    },

    moneyFilter(money) {
      if (typeof money !== "number") {
        return "--";
      }
      return money.toLocaleString();
    },

    progressFilter(value) {
      return typeof value === "number" ? value : "--";
    },
  },
};
</script>